import { Injectable } from '@angular/core';
import { from, type Observable } from 'rxjs';
import type { AdminLocationCategoryListDto } from '../../../../backend/main';
import {
  deleteLocationCategoryAsync,
  findLocationCategoryAsync,
  listAdminLocationCategoriesAsync,
} from '../../../../backend/main';
import type { DtoListService, GetAllRequestParameters, ListPaginatedDTO } from '@pct/ng-core-dto';
import { UNKNOWN_ITEM } from '@pct/ng-core-dto';
import type { FilteredParams } from '../../../common/request/filtered-params';
import { mapSort } from '../../../common/request/map-sort';
import { convertPaginationParams } from '../../../common/utils/table/convert-pagination-params';
import type { LocationsCategoryFilter } from './locations-category-filter';

@Injectable()
export class LocationsCategoryDtoService implements DtoListService<
  AdminLocationCategoryListDto,
  FilteredParams<AdminLocationCategoryListDto, LocationsCategoryFilter>
> {
  getAll(
    param: GetAllRequestParameters<
      FilteredParams<AdminLocationCategoryListDto, LocationsCategoryFilter>
    >,
  ): Observable<ListPaginatedDTO<AdminLocationCategoryListDto>> {
    return from(
      listAdminLocationCategoriesAsync({
        body: {
          pagination: convertPaginationParams(param.pagination),

          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          sort: mapSort(param.parameters?.sort) as any,
          searchText: param.parameters?.filter?.searchText,
          status: param.parameters?.filter?.status,
          language: param.parameters?.filter?.language,
        },
      }).then(resp => resp.data),
    );
  }

  getById(id: string): Observable<Partial<AdminLocationCategoryListDto>> {
    return from(
      findLocationCategoryAsync({ path: { id } }).then(({ data }) => {
        const translation =
          data.translations.find(t => t.language === 'hu') ??
          data.translations.find(t => t.language === 'en');
        return {
          id: data.id,
          name: translation?.name ?? 'N/A',
        };
      }),
    );
  }

  getDtoId(dto: AdminLocationCategoryListDto): string;
  getDtoId(dto: AdminLocationCategoryListDto | null | undefined): string | null | undefined;
  getDtoId(
    dto: Partial<AdminLocationCategoryListDto> | null | undefined,
  ): string | null | undefined;
  getDtoId(
    dto: AdminLocationCategoryListDto | Partial<AdminLocationCategoryListDto> | null | undefined,
  ): string | null | undefined {
    return dto?.id ?? null;
  }

  toString(dto: AdminLocationCategoryListDto): string {
    return dto.name ?? UNKNOWN_ITEM;
  }

  delete(id: string): Observable<void> {
    return from(
      deleteLocationCategoryAsync({ path: { id } }).then(() => {
        // type cast to void
      }),
    );
  }
}
